"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.password.placeholder': 'Enter password',
};
